import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';
import { loanStatus } from 'actions/aresActions';
import SignatureKey from './SignatureKey';
import preLoaderActions from 'actions/preLoaderActions';

const SignatureKeyAres = ({ getLoanStatus, preLoaderActions }) => {
    useEffect(() => {
        preLoaderActions.hidePreLoader();
    }, []);

    return <SignatureKey moveToNextStep={getLoanStatus} />;
};

SignatureKeyAres.propTypes = {
    getLoanStatus: PropTypes.func.isRequired,
    preLoaderActions: PropTypes.object.isRequired,
};

export default connect(
    state => ({ state }),
    dispatch => ({
        getLoanStatus: bindActionCreators(loanStatus, dispatch),
        preLoaderActions: bindActionCreators(preLoaderActions, dispatch),
    })
)(SignatureKeyAres);
